import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Checkbox, FormControlLabel } from '@material-ui/core'
import { AdditionalServicesOptions } from '../enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    containter: {
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      paddingBottom: theme.spacing(5),
      paddingTop: theme.spacing(5),
      width: '100%',
    },
    heading: {
      marginBottom: theme.spacing(3),
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
    },
    subHeading: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      paddingLeft: theme.typography.pxToRem(16),
    },
    annealingCheckbox: {
      fontSize: theme.typography.pxToRem(14),
      marginRight: theme.spacing(41.5),
    },
    annealingAndPoolingCheckbox: {
      fontSize: theme.typography.pxToRem(14),
      marginRight: theme.spacing(31.5),
    },
    checkbox: {
      fontSize: theme.typography.pxToRem(14),
    },
    hplcCheckbox: {
      fontSize: theme.typography.pxToRem(14),
      marginRight: theme.spacing(32),
    },
    checkboxBorder: {
      color: theme.palette.grey[500],
    },
    disabled: {
      '& span': {
        color: theme.palette.grey[400],
      },
    },
  }
})

const AdditionalServices = (props) => {
  const classes = useStyles()

  const isEnabled = (service: string) => {
    const index = props.product?.listAdditionalServices?.findIndex(
      (item) => item === service
    )
    return index !== -1 ? true : false
  }

  const hasItem = (service: string) => {
    if (!props.product?.additionalServices) return false
    const index = props.product?.additionalServices?.findIndex(
      (item) => item === service
    )
    return index === -1 ? false : true
  }

  return (
    <div className={classes.containter}>
      <div className={classes.heading}>
        <FormattedMessage {...messages.CONF_NGSO_ADDITIONAL_SERVICES} />
        <span className={classes.subHeading}>
          <FormattedMessage
            {...messages.CONF_NGSO_ADDITIONAL_SERVICES_SUBTEXT}
          />
        </span>
      </div>

      <Grid container direction="row">
        <Grid item>
          <FormControlLabel
            classes={{
              label: classes.annealingCheckbox,
              root: !isEnabled(AdditionalServicesOptions.Annealing)
                ? classes.disabled
                : '',
            }}
            value={AdditionalServicesOptions.Annealing}
            control={<Checkbox className={classes.checkboxBorder} />}
            label={
              <FormattedMessage
                {...messages.CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING}
              />
            }
            checked={hasItem(AdditionalServicesOptions.Annealing)}
            disabled={!isEnabled(AdditionalServicesOptions.Annealing)}
            onChange={(e) => props.handleCheck(e)}
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            classes={{
              label: classes.annealingAndPoolingCheckbox,
              root: !isEnabled(AdditionalServicesOptions.AnnealingAndPooling)
                ? classes.disabled
                : '',
            }}
            value={AdditionalServicesOptions.AnnealingAndPooling}
            control={<Checkbox className={classes.checkboxBorder} />}
            label={
              <FormattedMessage
                {...messages.CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING_POOLING}
              />
            }
            checked={hasItem(AdditionalServicesOptions.AnnealingAndPooling)}
            disabled={!isEnabled(AdditionalServicesOptions.AnnealingAndPooling)}
            onChange={(e) => props.handleCheck(e)}
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            classes={{
              label: classes.checkbox,
              root: !isEnabled(AdditionalServicesOptions.AnnealingQC)
                ? classes.disabled
                : '',
            }}
            value={AdditionalServicesOptions.AnnealingQC}
            control={<Checkbox className={classes.checkboxBorder} />}
            label={
              <FormattedMessage
                {...messages.CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING_QC}
              />
            }
            checked={hasItem(AdditionalServicesOptions.AnnealingQC)}
            disabled={!isEnabled(AdditionalServicesOptions.AnnealingQC)}
            onChange={(e) => props.handleCheck(e)}
          />
        </Grid>
        {props.productDetails.isCSRSupervisor ? (
          <Grid container direction="row">
            <Grid item>
              <FormControlLabel
                classes={{
                  label: classes.hplcCheckbox,
                }}
                value={AdditionalServicesOptions.HPLC}
                control={<Checkbox color="primary" />}
                label={
                  <FormattedMessage {...messages.CONF_NGSO_ANALYTICAL_HPLC} />
                }
                checked={
                  props.product?.analyticalHPLC ===
                  AdditionalServicesOptions.HPLC
                    ? true
                    : false
                }
                onChange={(e) => props.saveHPLC(e)}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                classes={{
                  label: classes.checkbox,
                }}
                value={AdditionalServicesOptions.COA}
                control={<Checkbox color="primary" />}
                label={
                  <FormattedMessage
                    {...messages.CONF_NGSO_CERTIFICATE_OF_ANALYSIS}
                  />
                }
                checked={
                  props.product?.certificateOfAnalysis ===
                  AdditionalServicesOptions.COA
                    ? true
                    : false
                }
                onChange={(e) => props.saveCOA(e)}
              />
            </Grid>
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    </div>
  )
}

export default AdditionalServices
